import React from "react";
import AllProducts from "../../components/Shop/AllProducts";

const ProfileProducts = () => {
  return <AllProducts />;
};

export default ProfileProducts;

